import { Component, Input } from '@angular/core';
import { Vessel } from 'icreate/common/models/vessel';
import dayjs from 'dayjs';

@Component({
    selector: 'app-created-folder-panel',
    templateUrl: './created-folder-panel.component.html',
    styleUrls: [
        './created-folder-panel.component.css',
        '../version-history-changes-panel/version-history-changes-panel.component.css',
    ],
    standalone: false,
})
export class CreatedFolderPanelComponent {
    @Input() vessel: Vessel;
    templateText;

    ngOnInit(): void {
        if (this.vessel.templateVersion) {
            this.templateText = `${this.vessel.templateShipyard} ${this.vessel.templateVessel} Version ${this.vessel.templateVersion}`;
        }
    }

    getCreatedDate() {
        if (this.vessel.creationDate) {
            return dayjs(this.vessel.creationDate).format('MMM DD, YYYY, HH:mm:ss');
        }
        return '';
    }
}
